const eventId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export function pushDataLayer(payload) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...payload, event_id: payload.event_id || eventId() });
}

let lastVirtualPath = "";
let lastVirtualAt = 0;

export function trackVirtualPageView({ pathname, search, title }) {
  const pagePath = `${pathname}${search || ""}`;
  const now = Date.now();
  if (pagePath === lastVirtualPath && now - lastVirtualAt < 1000) return;
  lastVirtualPath = pagePath;
  lastVirtualAt = now;
  pushDataLayer({
    event: "virtual_page_view",
    page_path: pagePath,
    page_title: title || document.title,
    page_location: window.location.href,
  });
  // GA4 (gtag.js) SPA pageview so every route is measured, not just the first load
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: title || document.title,
      page_location: window.location.href,
      page_path: pagePath,
    });
  }
}

export function trackSuccessfulEnquiry({ isAdmission = false, requestedService = "", membershipTier = "" }) {
  if (isAdmission) {
    pushDataLayer({
      event: "membership_application_submitted",
      enquiry_type: "membership_application",
      membership_tier: membershipTier,
      form_location: window.location.pathname,
      lead_source: "delux_concierge_website",
    });
    return;
  }

  pushDataLayer({
    event: "enquiry_submitted",
    enquiry_type: requestedService ? "service" : "general",
    requested_service: requestedService || undefined,
    form_location: window.location.pathname,
    lead_source: "delux_concierge_website",
  });
}

export function installContactClickTracking() {
  if (typeof window === "undefined" || window.__dcContactTrackingInstalled) return () => {};
  window.__dcContactTrackingInstalled = true;

  const handler = (event) => {
    const link = event.target?.closest?.("a[href]");
    if (!link) return;
    const href = link.getAttribute("href") || "";
    let method = "";
    if (href.startsWith("tel:")) method = "phone";
    else if (href.startsWith("mailto:")) method = "email";
    else if (href.includes("wa.me") || href.includes("api.whatsapp.com") || href.startsWith("whatsapp:")) method = "whatsapp";
    if (!method) return;

    const testId = link.getAttribute("data-testid");
    pushDataLayer({
      event: "contact_engagement",
      contact_method: method,
      link_location: testId || (link.closest("footer") ? "footer" : window.location.pathname),
    });
  };

  document.addEventListener("click", handler, true);
  return () => {
    document.removeEventListener("click", handler, true);
    window.__dcContactTrackingInstalled = false;
  };
}
